import { render, staticRenderFns } from "./m-button.vue?vue&type=template&id=73c8b30c&scoped=true&"
import script from "./m-button.vue?vue&type=script&lang=js&"
export * from "./m-button.vue?vue&type=script&lang=js&"
import style0 from "./m-button.vue?vue&type=style&index=0&id=73c8b30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8b30c",
  null
  
)

export default component.exports